import { Component, OnDestroy, OnInit } from '@angular/core';
import { Params, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { faDownload, faNewspaper } from '@fortawesome/free-solid-svg-icons';
import { environment } from '../../../environments/environment';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { LoaderComponent } from '../../shared/components/loader/loader.component';
import { DatePipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { ArticleService } from "../../services/article.service";
import { IArticleAttachment, IArticle } from '../../services/models/articles.model';
import { FileService } from '../../services/file.service';
import { IApiResponse } from '../../shared/models/api-reponse.model';
import { NoSanitizePipe } from "../../shared/directives/no-sanitize/no-sanitize.directive";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-article',
  standalone: true,
  imports: [FaIconComponent, DatePipe, NgIf, NgClass, NgForOf, NoSanitizePipe],
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit, OnDestroy {
  // Icons
  protected readonly faNews = faNewspaper;
  protected readonly faDownload = faDownload;

  // Component variables
  protected article: IArticle | null = null;
  protected imageUrl: string = '';
  protected hasImage: boolean = true;
  protected placeholderImage: string = '';
  protected attachments: IArticleAttachment[] = [];

  // General variables
  protected loading: boolean = false;
  protected readonly env = environment;
  private unsubscribe: Subject<any> = new Subject<any>();

  constructor(private sanitizer: DomSanitizer,
              private fileService: FileService,
              private modalService: NgbModal,
              private articleService: ArticleService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    this.placeholderImage = `${this.env.SiteUrls.AzureStorageBaseURL}${environment.SiteUrls.NewsImagePlaceHolderUrl}`;
    this.route.params.subscribe((params: Params) => {
      const articleId = params['id'];
      if (articleId && articleId > 0) {
        this.getArticle(articleId);
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(null);
    this.unsubscribe.complete();
  }

  initArticle() {
    this.article = null;
  }

  getArticle(articleId: number) {
    this.loading = true;
    this.articleService.get(articleId)
      .subscribe({
        next: (data) => {
          this.article = {...data};
          this.setImageUrl();
          this.getAttachments();
          this.loading = false;
        },
        error: () => {
          this.initArticle();
          this.loading = false;
        }
      });
  }

  getAttachments() {
      this.articleService.getAttachments(this.article!.ArticleId)
        .subscribe({
          next: (data) => {
            this.loading = false;
            this.attachments = [...data];
            this.article!.TotalAttachments = this.attachments?.length ?? 0;
          }, error: (err: IApiResponse) => {
            this.article!.TotalAttachments = 0;
            this.loading = false;
          }
        });
  }

  downloadAttachment(reference: string) {
    this.fileService.GetFile(environment.ContainerNames.ArticleAttachment, reference);
  }

  sanitizeArticleContent(article: string) {
    return this.sanitizer.bypassSecurityTrustHtml(article);
  }

  setImageUrl() {
    this.imageUrl = `${environment.SiteUrls.AzureStorageBaseURL}${environment.ContainerNames.ArticleImages}/${this.article?.ArticleId}/${this.article?.ImageReference}`;
  }

  viewContactCard(userId: number) {
    // Open modal to edit user
    // const modalRef = this.modalService.open(UserContactModalComponent, { size: 'md', centered: true, backdrop: 'static' });
    // modalRef.componentInstance.UserID = userId;
  }
}
